import {AnyAction} from 'redux';
import {ExtraReducer as State} from '../../@types/reducers';
import {
    BOOK_EVENT_SUCCESS,
    DELETE_ALERT_SUCCESS,
    DELETE_EXTRA_SETTINGS_SUCCESS,
    EDIT_EXTRA_EVENT,
    EXTRA_INITIALIZE_SUCCESS,
    GET_EVENT_SUCCESS,
    GET_EXTRA_EVENTS,
    GET_EXTRA_EVENTS_SUCCESS,
    GET_EXTRA_SETTINGS_SUCCESS,
    HIDE_ALERT_SUCCESS,
    NEW_BOOKED_EVENT,
    NEW_HIDDEN_ALERT,
    SET_ACTIVE_EXTRA,
    SET_ORDER,
    SET_SETTINGS,
    STORE_EXTRA_INITIALIZE,
} from "../../constants/ExtraConstants";
import {processEvent} from "../utils/extraUtils";
import {GET_BOOKS_SUCCESS} from "../../constants/UserConstants";
import {AlertExtraObject, ExtraProcessingEvent} from '../../@types/response';
import {MarginMethod} from "../../constants/CommonConstants";
import {ActiveEventIds} from "../utils/searchFixtures";

const initialState: State = {
    initializing: true,
    event: undefined,
    extras: [],
    booked: [],
    hides: {},
    books: [],
    activeEventIds: new Set<number>(),
    template: null,
    templates: [],
    settings: {
        bookmakers: [],
        comparisons: {
            '0': {
                status: true,
                method: MarginMethod.NEW,
                threshold: -10,
                level0: 0,
                level1: -1,
                bookmakers: [1, 12, 107],
            },
        },
        date: 0,
        from: 1,
        to: 1,
        order: 3,
        onlyDrop: false,
        playability: 0,
        sports: {1: true, 2: true, 5: true}
    }
};

const extraReducer = (state = initialState, action: AnyAction): State => {
    switch (action.type) {
        case SET_SETTINGS: {
            const settings = Object.assign({}, state.settings, action.payload)
            return {
                ...state,
                settings: settings,
            }
        }
        case STORE_EXTRA_INITIALIZE: {
            if (state.templates.includes(action.payload.name))
                return state
            return {
                ...state,
                templates: [...state.templates, action.payload.name]
            }
        }
        case EXTRA_INITIALIZE_SUCCESS: {
            return {
                ...state,
                initializing: false,
                booked: action.payload.booked,
                hides: action.payload.hides,
                books: action.payload.books,
                templates: [],
            };
        }
        case GET_EXTRA_SETTINGS_SUCCESS: {
            return {
                ...state,
                initializing: false,
                settings: action.payload.settings,
                template: action.payload.template
            };
        }
        case DELETE_EXTRA_SETTINGS_SUCCESS: {
            return {
                ...state,
                templates: state.templates.filter((item: string) => item !== action.payload.template)
            };
        }
        case GET_EXTRA_EVENTS: {
            return {
                ...state,
                initializing: true
            }
        }
        case GET_EXTRA_EVENTS_SUCCESS: {
            const extras: AlertExtraObject[] = action.payload.map((e: ExtraProcessingEvent) => processEvent(e, state.settings, state.booked, state.hides)).flat()
            return {
                ...state,
                extras,
                initializing: false
            };
        }
        case EDIT_EXTRA_EVENT: {
            const _newAlerts: AlertExtraObject[] = processEvent(action.payload.event, state.settings, state.booked, state.hides)
            const _rmAlerts = state.extras.filter(_m => _m.id !== action.payload.event._id)
            let _extras = !_newAlerts.length && state.extras.length === _rmAlerts.length ? state.extras :
                _rmAlerts.concat(_newAlerts)
            const eventId: number = action.payload.event._id
            const hasActive: boolean = !!action.payload.event.bookmakers
                && Object.keys(action.payload.event.bookmakers).length > 0
            const activeEventIds = new Set(state.activeEventIds)
            if (hasActive) {
                activeEventIds.add(eventId)
            } else {
                activeEventIds.delete(eventId)
            }
            return {
                ...state,
                extras: _extras,
                activeEventIds,
            };
        }
        case SET_ORDER: {
            return {
                ...state,
                settings: Object.assign({}, state.settings, {order: action.payload})
            };
        }
        case SET_ACTIVE_EXTRA: {
            const activeEventIds: ActiveEventIds = new Set<number>(action.payload)
            return {
                ...state,
                activeEventIds,
            };
        }
        case GET_EVENT_SUCCESS: {
            return {
                ...state,
                event: action.payload
            };
        }
        case GET_BOOKS_SUCCESS: {
            return {
                ...state,
                books: action.payload
            };
        }
        case BOOK_EVENT_SUCCESS:
        case NEW_BOOKED_EVENT: {
            const booked = [...state.booked, action.payload]
            return {
                ...state,
                booked: booked,
                extras: state.extras.filter(alert => action.payload !== `${alert.id}-${alert.marketId}@${alert.sbv}-${alert.signId}`)
            };
        }
        case DELETE_ALERT_SUCCESS: {
            return {
                ...state,
                extras: state.extras
                    .filter(alert => {
                        return !(alert.id === action.payload.eventId
                            && alert.marketId === action.payload.marketId)
                    })
            }
        }
        case HIDE_ALERT_SUCCESS:
        case NEW_HIDDEN_ALERT: {
            const hides = Object.assign({}, state.hides, action.payload)
            return {
                ...state,
                hides: hides,
                extras: state.extras.filter(alert => !Object.keys(action.payload).includes(`${alert.id}-${alert.marketId}@${alert.sbv}-${alert.signId}`))
            };
        }
        default:
            return state;
    }
};

export default extraReducer;
